import { render, staticRenderFns } from "./ActivityIndex.vue?vue&type=template&id=09664719&scoped=true&"
import script from "./ActivityIndex.vue?vue&type=script&lang=ts&"
export * from "./ActivityIndex.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityIndex.vue?vue&type=style&index=0&id=09664719&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09664719",
  null
  
)

export default component.exports